import { render, staticRenderFns } from "./1introduce.vue?vue&type=template&id=1175f9bc&scoped=true&"
import script from "./1introduce.vue?vue&type=script&lang=js&"
export * from "./1introduce.vue?vue&type=script&lang=js&"
import style0 from "./1introduce.vue?vue&type=style&index=0&id=1175f9bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175f9bc",
  null
  
)

export default component.exports